// Datetimes tz-aware do backend (Pydantic v2) já vêm com o fuso no fim (ex: "+00:00") —
// colar mais um "Z" nesse caso gera "...+00:00Z", que o JS não consegue interpretar (Invalid
// Date). Só completa com "Z" quando o fuso realmente estiver ausente.
const TEM_FUSO = /(Z|[+-]\d{2}:\d{2})$/;
const comFuso = (iso) => (TEM_FUSO.test(iso) ? iso : `${iso}Z`);

export const formatDate = (iso) => (iso ? new Date(comFuso(iso)).toLocaleDateString('pt-BR') : '—');

// Para campos `date` puros (YYYY-MM-DD, sem horário) vindos do backend — não anexar 'Z'.
export const formatDateOnly = (isoDate) => {
  if (!isoDate) return '—';
  const [ano, mes, dia] = isoDate.split('-');
  return `${dia}/${mes}/${ano}`;
};

export const formatDateTime = (iso) => (iso ? new Date(comFuso(iso)).toLocaleString('pt-BR') : '—');

export const todayIso = () => new Date().toISOString().slice(0, 10);

export const addOneYear = (iso) => {
  const d = new Date(iso);
  d.setFullYear(d.getFullYear() + 1);
  return d.toISOString().slice(0, 10);
};

const MESES_ABREV = ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'];

// Para `mes_referencia` (YYYY-MM-DD, sempre dia 1) vindo do histórico de conformidade.
export const formatMesAbrev = (isoDate) => {
  if (!isoDate) return '';
  const [ano, mes] = isoDate.split('-');
  return `${MESES_ABREV[Number(mes) - 1]}/${ano.slice(2)}`;
};
